export default {
  TodoListAction_Renew: 'Renew',
  TodoListAction_Confirm: 'Confirm',
  TodoListState_Expired: 'Expired',
  TodoListState_Todo: 'Expires',
  TodoList_LicensingEntity_publicSector: 'Public-Sector Employee',
  TodoList_LicensingEntity_tdlr: 'Texas Department of Licensing and Regulation',
};
